import { render, staticRenderFns } from "./AppHorizontalList.vue?vue&type=template&id=fa9929ca&scoped=true&"
import script from "./AppHorizontalList.vue?vue&type=script&lang=js&"
export * from "./AppHorizontalList.vue?vue&type=script&lang=js&"
import style0 from "./AppHorizontalList.vue?vue&type=style&index=0&id=fa9929ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9929ca",
  null
  
)

export default component.exports